<template>
    <div :class="{ 'flex' : ! commentExists, 'block w-full' : commentExists }">
        <button
            v-if="! commentExists"
            class="btn btn-md is-ghost align-top px-2xl"
            @click="$modal.show(orderCommentModalName)"
        >
            Orderkommentar
        </button>
        <div
            v-if="commentExists"
            class="bg-accent-beach-beige-light p-md rounded mb-md"
        >
            <div class="flex items-center justify-between">
                <div>
                    <span class="font-semibold">Orderkommentar</span>
                    <br>
                    <span class="text-xs">{{ comment.user.name }} {{ updatedAt }}</span>
                </div>
                <div class="flex">
                    <button
                        class="btn-icon hover:bg-danger hover:border-danger"
                        @click="$modal.show(deleteCommentModalName)"
                    >
                        <font-awesome-icon
                            icon="trash-alt"
                            size="xs"
                        />
                    </button>
                    <button
                        class="btn-icon"
                        @click="$modal.show(orderCommentModalName)"
                    >
                        <font-awesome-icon
                            icon="pencil-alt"
                            size="xs"
                        />
                    </button>
                </div>
            </div>

            <!-- eslint-disable vue/no-v-html -->
            <p class="mt-md mb-0" v-html="comment.body_formatted" />
        </div>

        <adaptive-form-modal
            :name="orderCommentModalName"
            primary-button-text="Kommentera"
            primary-button-class="is-primary"
            title="Orderkommentar"
            :callback="commentWasStored"
            method="PATCH"
            :action="route('api.orders.comments.update', order)"
        >
            <textarea
                v-model="body"
                name="body"
                class="form-input"
                rows="5"
                required
            />
        </adaptive-form-modal>

        <adaptive-form-modal
            :name="deleteCommentModalName"
            primary-button-text="Ta bort kommentar"
            primary-button-class="is-danger"
            title="Ta bort orderkommentar"
            :callback="commentWasDeleted"
            method="DELETE"
            :action="route('api.orders.comments.destroy', order)"
        >
            <p>Är du helt säker på att du vill radera orderkommentaren?</p>
        </adaptive-form-modal>
    </div>
</template>

<script>
    import OrderCommentBase from './OrderCommentBase';

    export default {
        extends: OrderCommentBase,
    };
</script>
